import React, { useState } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { useMutation } from "@tanstack/react-query";
import { updateData } from "../../utility/adminApi";

function LowStockLimitModal({
  setLowStockLimitModal,
  id,
  fetchData,
  profileDetails,
}) {
  const [newValue, setNewValue] = useState();

  const [newData, setNewData] = useState({
    low_stock_limit: profileDetails?.user?.company?.low_stock_limit || 0,
  });

  const handleChange = (e) => {
    const { name, value } = e.target; // Destructure name and value from event target
    setNewValue(value);
    setNewData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in state
    }));
  };

  const lowStockUpdate = useMutation({
    mutationFn: (newData) =>
      updateData(`products/low-stock-limit/`, id, newData),
    onSuccess: () => {
      setLowStockLimitModal(false);
      setNewData({
        low_stock_limit: newValue,
      });
    },
  });

  const handleClose = () => {
    setLowStockLimitModal(false);
  };

  const handleUpdate = () => {
    lowStockUpdate.mutate(newData);
  };
  return (
    <div className="fixed inset-0 flex items-center justify-center  bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6">
        <div className="flex justify-end">
          <CancelIcon
            onClick={handleClose}
            className="cursor-pointer text-black mb-2"
          />
        </div>
        <div className="font-semibold text-2xl text-center pb-4">
          Set Low Stock Limit
        </div>
        <div className=" items-center gap-3 justify-center mb-2">
          <h3 className="font-semibold text-center pb-1">Low Stock limit :</h3>
          <input
            className="border-2 border-gray-300 p-2 rounded-md w-full focus:border-teal-500 focus:outline-none lg:w-[400px]"
            placeholder="Low stock limit"
            type="number"
            name="low_stock_limit"
            // id="email"
            value={newData?.low_stock_limit}
            onChange={handleChange}
            // required
          />
        </div>
        <button
          onClick={() => handleUpdate()}
          type="submit"
          className="px-4 py-3 mt-4 text-white rounded-lg w-full lg:w-[400px] bg-blue-500"
        >
          Update
        </button>
      </div>
    </div>
  );
}

export default React.memo(LowStockLimitModal);
